import { ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR, ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR } from './actionTypes'
import { ACCOMMODATIONS_COMPARATOR_SET_REGION, ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE } from './actionTypes'

export function accommodationsAddComparator() { return { type: ACCOMMODATIONS_COMPARATOR_ADD_COMPARATOR }}
export function accommodationsRemoveComparator() { return { type: ACCOMMODATIONS_COMPARATOR_REMOVE_COMPARATOR }}

export function accommodationsSetRegion(comparatorIndex, region) { return { type: ACCOMMODATIONS_COMPARATOR_SET_REGION, comparatorIndex, region }}
export function accommodationsSetDataType(comparatorIndex, dataType) { return { type: ACCOMMODATIONS_COMPARATOR_SET_DATA_TYPE, comparatorIndex, dataType }}


// WEBPACK FOOTER //
// ./src/actions/accommodationsComparator.js